import React from "react";
import ReactDom from "react-dom";
import CPLForm from "./CPLForm.jsx";

export function initCPLForm() {
  const div = document.querySelector(".js-cpl-form");
  if (div) {
    if (!window.grecaptcha) {
      const script = document.createElement("script");
      // Site Key owned by Stewart Title
      // As of August 2025, was not configured to work with localhost requests
      // so this will never submit successfully in Storybook.
      script.src =
        "https://www.google.com/recaptcha/api.js?render=6Lc8rwYaAAAAAGsJKqZhD-FjPHtuq1D56kx47AnM";
      document.body.appendChild(script);
    }
    ReactDom.render(<CPLForm />, div);
  }
}
